import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Intro = () => {
  return (
    <Box
      margin={{ xs: "35% 0% 25% 0%", sm: "10%" }}
      width={{ xs: "95%", sm: "80%" }}
    >
      <Typography
        variant="h4"
        color={"#39484E"}
        paddingBottom={{ xs: "4%", sm: "2%" }}
        textAlign={"center"}
        fontWeight={700}
      >
        The Fund harnesses Africa’s diversity of talent, creativity, and
        untapped potential to drive a continent-wide shift toward adaptability
        and self-sufficiency.
      </Typography>
      <Typography
        variant="body1"
        color={"#4f4f4f"}
        paddingBottom={{ xs: "4%", sm: "2%" }}
        paddingTop={{ xs: "5%", sm: "0%" }}
        textAlign={"center"}
      >
        The AIR Fund focuses on five strategic goals: <strong>(1)</strong>{" "}
        advancing civic innovation, <strong>(2)</strong> building climate
        resilience, <strong>(3)</strong> expanding economic opportunities,{" "}
        <strong>(4)</strong> supporting innovation ecosystems, and{" "}
        <strong>(5)</strong> leveraging AI for social good. By awarding grants
        ranging from $15,000 to $50,000, the AIR Fund enables nonprofits,
        grassroots organizations, and local innovators to deliver targeted
        solutions in governance, education, healthcare, and climate action. For
        instance, AI-driven tools for urban planning have increased citizen
        participation by 50%, while community-driven climate adaptation
        initiatives have protected agricultural livelihoods and reduced food
        insecurity for millions.
      </Typography>
      <Typography variant="body1" color={"#4f4f4f"} textAlign={"center"}>
        The AIR Fund prioritizes localized impact by targeting secondary cities,
        which house nearly 40% of Africa’s urban population yet receive less
        than 5% of global climate adaptation funding. By directing resources to
        high-need regions like
        <strong>
          {" "}
          Nigeria, Kenya, Ghana, Senegal, Côte d’Ivoire, Zambia, and Tanzania
        </strong>
        , the AIR Fund ensures that its support drives meaningful change where
        it matters most. At AIR, we fund projects such as low-cost climate
        sensors for real-time flood monitoring, which have saved thousands of
        lives annually, and affordable AI-powered tools that enhance urban
        resilience.
      </Typography>
    </Box>
  );
};

export default Intro;
